import { IS4 } from '@/common/pd-meta-components-types'
import { FC, useRef, useState } from 'react'
import TitleAndDesc from '../../title-and-desc'
import clsx from 'clsx'
import PdMedia from '@/components/pd-media/pd-media'
import { gsap } from 'gsap'
import { useGSAP } from '@gsap/react'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'
import PdTextMatchSup from '@/components/pd-text-match-sup/pd-text-match-sup'

gsap.registerPlugin(useGSAP, ScrollTrigger)

const S4: FC<IS4> = ({ theme, title, titleTag, itemTitleTag, desc, mediaUrl = '', tagList = [] }) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const titleRef = useRef<HTMLDivElement>(null)
  const mediaRef = useRef<HTMLDivElement>(null)
  const tagListRef = useRef<HTMLDivElement>(null)
  const [vedioCommand, setVedioCommand] = useState<'PLAY' | 'PAUSE'>('PAUSE')
  useGSAP(() => {
    if (!mediaUrl) return
    ScrollTrigger.refresh()
    const tl = gsap.timeline({
      scrollTrigger: {
        scroller: '#main',
        trigger: containerRef.current,
        start: 'top top',
        end: () => `+=${window.innerHeight * 3}`,
        pin: true,
        pinType: 'fixed',
        scrub: 0.3,
        onEnter: () => {
          setVedioCommand('PLAY')
        },
        onLeaveBack: () => {
          setVedioCommand('PAUSE')
        },
      },
    })

    tl.fromTo(
      mediaRef.current,
      {
        scale: 1.6,
      },
      {
        scale: 1,
      }
    ).fromTo(
      [titleRef.current, tagListRef.current],
      {
        opacity: 0,
      },
      {
        opacity: 1,
      }
    )
    return () => {
      tl?.kill()
    }
  }, [mediaUrl])
  return (
    <div
      className={clsx(
        'w-full h-fit',
        'py-15 laptop:py-30 overflow-hidden min-h-screen',
        `pd-theme-${theme}`,
        'bg-container-primary',
        'pointer-events-none'
      )}
      ref={containerRef}
    >
      <div ref={titleRef} style={{ opacity: 0 }}>
        <TitleAndDesc title={title} desc={desc} titleTag={titleTag} />
      </div>
      <div className={clsx('w-full max-w-300 mx-auto', 'flex flex-col items-center', 'px-6 laptop:px-0')}>
        <div
          className={clsx('w-230px h-230px laptop:w-428px laptop:h-428px', 'mb-5')}
          ref={mediaRef}
          style={{ transform: 'scale(1.6)' }}
        >
          <PdMedia src={mediaUrl} mask={false} showShadow={false} loop={false} videoCommand={vedioCommand} />
        </div>
        <div className={clsx('flex gap-x-5 laptop:gap-x-10')} ref={tagListRef}>
          {tagList.map((tag) => (
            <div key={tag.title} className={clsx('flex flex-col items-center')}>
              <div className={clsx('w-25px h-25px laptop:w-50px laptop:h-50px')}>
                <PdMedia src={tag.mediaUrl || ''} mask={false} showShadow={false} />
              </div>
              <div
                className={clsx('w-25px h-px laptop:w-50px', 'mt-10px mb-1 laptop:mt-5 laptop:mb-2', 'bg-fc-secondary')}
              />
              <PdTextMatchSup
                as={itemTitleTag}
                className={clsx('text-center', 'text-fc-secondary pd-main-text')}
                supClassName="text-[12px] relative -top-[8px]"
                text={tag.title || ''}
              ></PdTextMatchSup>
            </div>
          ))}
        </div>
      </div>
    </div>
  )
}

export default S4
